import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestData } from 'src/app/common/models/request-data.model';
import { CustomizationModel } from '../model/customization.model';
import { CustomizationService } from '../customization.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PermissionService } from 'src/app/auth/permission.service';
import { AppConstants } from 'src/app/common/app.constants';
@Component({
  selector: 'app-customization-edit',
  templateUrl: './customization-edit.component.html',
  styleUrls: ['./customization-edit.component.scss'],
  standalone: false
})
export class CustomizationEditComponent implements DirtyCheck {
  title: string = "New Menu";
  editForm!: FormGroup;
  customizationInfo: CustomizationModel = { customizationOptionValues: [], is_active: 1 };
  isFormDirty: boolean = false;
  ratingList: CustomizationModel[] = [];
  context: any;
  departments: any;
  selectedDepartments: any[] = [];
  optionForList: any = [];
  customizationOptionValues: any;
  defaultOptionId: any;
  showPriceColumn: boolean = false;
  showQuantityColumn: boolean = false;
  saleItems: any[] = [];
  permission: any;
  filteredSaleItems!: Observable<any[]>;
  // Add this property to track if sale items are already being loaded
  private loadingSaleItems = false;
  // Class property to store the promise for loading sale items
  private saleItemsLoadPromise: Promise<void> | null = null;
  filteredSaleItemsArray: any[][] = [];

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private customizationService: CustomizationService, // Service for customization-related API calls
    private snackBarService: SnackBarService, // Service for displaying notification messages
    public dialog: MatDialog, private permissionService: PermissionService) { // Dialog service for modal dialogs

    // Get customization ID from route parameters
    let customizationId = this.route.snapshot.paramMap.get('id');

    // Initialize the form regardless of whether it's a new or existing customization
    this.customizationInfo = { customizationOptionValues: [], is_active: 1 };

    // If editing existing customization, load its data
    if (customizationId !== null && parseInt(customizationId) !== 0) {
      // Load sale items first to ensure they're available
      this.loadSaleItems();
      this.setMenuInfo(customizationId);
    }
    else {
      const customizationData = history.state.customizationData;
      // For new customization, initialize the form and load sale items
      if (customizationData) {
        this.loadSaleItems();
        this.initForm(customizationData);
      } else {
        this.loadSaleItems();
        this.title = this.getTitle();
        this.initForm();
        this.addOption();
        this.isFormDirty = false;
      }
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission('customization'), customizationId);
  }

  /**
   * Initialize component data on init
   */
  ngOnInit(): void {
    // Set up options for the "option_for" dropdown
    this.optionForList = [
      { id: 'both', name: 'Both' },
      { id: 'sushi', name: 'Sushi' },
      { id: 'bento', name: 'Bento' }
    ];

    // No need to call loadSaleItems() here as it's already called in the constructor

    // Only update column visibility if the form exists
    if (this.editForm) {
      this.updateDynamicColumnVisibility();
    }
  }
  onEnter(event: any) {
    event.preventDefault();
  }
  /**
   * Loads sale items from the server for dropdown selection
   * Returns a promise that resolves when sale items are loaded
   */
  loadSaleItems() {
    const storedSaleItems = sessionStorage.getItem(AppConstants.SESSION_VAR_CUST_SALE_ITEMS);
    if (storedSaleItems) {
      this.saleItems = JSON.parse(storedSaleItems);
    }
  }
  // loadSaleItems(): Promise<void> {
  //   // If we already have a promise, return it to avoid duplicate calls
  //   if (this.saleItemsLoadPromise) {
  //     console.log('Using existing sale items load promise');
  //     return this.saleItemsLoadPromise;
  //   }

  //   // If items are already loaded, return a resolved promise
  //   if (this.saleItems && this.saleItems.length > 0) {
  //     console.log('Sale items already loaded, using cached data');
  //     return Promise.resolve();
  //   }

  //   console.log('Creating new sale items load promise');

  //   // Create a new promise and store it
  //   this.saleItemsLoadPromise = new Promise((resolve) => {
  //     const requestData: RequestData =
  //     {
  //       search: {
  //         filters: {
  //           scope: {
  //             limit: 2000,
  //             offset: 0
  //           }
  //         },
  //         sort: [

  //         ]
  //       }
  //     };

  //     console.log('Making API call to load sale items');

  //     // Call API to get sale items

  //     this.customizationService.getSaleItems(requestData).subscribe({
  //       next: (response: any) => {
  //         if (response.status === 'SUCCESS') {
  //           this.saleItems = response.data.items;
  //           // Sort sale items by name in ascending order
  //           this.saleItems.sort((a, b) => a.name.localeCompare(b.name));
  //           console.log('Sale items loaded successfully:', this.saleItems.length);
  //         } else {
  //           console.error('Failed to load sale items:', response.message);
  //         }
  //         resolve(); // Resolve the promise regardless of success/failure
  //       },
  //       error: (error: any) => {
  //         console.error('API error when loading sale items:', error);
  //         resolve(); // Resolve the promise even on error
  //       }
  //     });
  //   });

  //   return this.saleItemsLoadPromise;
  // }

  /**
   * Determines which columns to display based on form values
   */
  updateDynamicColumnVisibility() {
    // Check if any option has price or quantity values
    const control = this.editForm?.get('customizationOptionValues') as FormArray;
    if (control) {
      this.showPriceColumn = control.controls.some(ctrl =>
        ctrl.get('price')?.value !== null && ctrl.get('price')?.value !== undefined
      );

      this.showQuantityColumn = control.controls.some(ctrl =>
        ctrl.get('quantity')?.value !== null && ctrl.get('quantity')?.value !== undefined
      );
    }
  }
  // getMenuDepartments() {
  //   this.customizationService.getMenuDepartments().subscribe({
  //     next: (response) => {
  //       if (response.status == 'SUCCESS') {
  //         this.departments = response.data.departments;
  //         this.initForm();
  //       }
  //     },
  //     error: (error) => {
  //       let snackBarData: SnackBarData = {
  //         message: 'Failed to get expense type from server. Connection to the server failed.',
  //         title: 'Failed!!!',
  //         type: 'error'
  //       }
  //       this.snackBarService.openSnackBar(snackBarData);
  //     }
  //   });
  // }

  initForm(customizationInfo?: CustomizationModel) {
    this.editForm = this.builder.group({
      code: this.builder.control(customizationInfo?.code || '', [Validators.required, Validators.maxLength(10)]),
      name: this.builder.control(customizationInfo?.name || '', [Validators.required, Validators.maxLength(50)]),
      description: this.builder.control(customizationInfo?.description || ''),
      display_name: this.builder.control(customizationInfo?.display_name || '', [Validators.required, Validators.maxLength(50)]),
      display_order: this.builder.control(customizationInfo?.display_order || '', [Validators.min(0)]),
      option_for: this.builder.control(customizationInfo?.option_for || '', [Validators.required]),
      customizationOptionValues: this.builder.array(customizationInfo?.customizationOptionValues?.map(opt => this.createOptionGroup(opt)) || []), // initialize array
      bg_color: this.builder.control(customizationInfo?.bg_color || '#FFFFFF'),
      fg_color: this.builder.control(customizationInfo?.fg_color || '#000000'),
    });
    this.editForm.valueChanges.subscribe(() => {
      if (this.editForm.dirty) {
        this.isFormDirty = true;
      }
    });
    this.editForm.get('customizationOptionValues')?.valueChanges.subscribe(() => {
      this.updateDynamicColumnVisibility();
    });
    this.filteredSaleItems = this.editForm.get('sale_item')?.valueChanges.pipe(
      startWith(''),
      map(value => this._filterSaleItems(value || ''))
    ) || of([]);
  }

  get options(): FormArray {
    return this.editForm.get('customizationOptionValues') as FormArray;
  }

  createOptionGroup(opt: any) {
    // console.log('Creating option group with:', opt);
    let saleItem = null;
    let price = opt.price || '';
    if (opt.sale_item && typeof opt.sale_item === 'object') {
      saleItem = opt.sale_item;
      // If quantity is not present, default to 1
      if (opt.quantity === undefined || opt.quantity === null) {
        opt.quantity = 1;
      }
    } else if (opt.sale_item_id && Number(opt.sale_item_id) > 0) {
      const saleItemId = Number(opt.sale_item_id);
      saleItem = this.saleItems.find(item => item.id == saleItemId) || null;
    }

    const group = this.builder.group({
      id: [opt.id],
      name: [opt.name, Validators.required],
      online_name: [opt.name_oo],
      name_to_print: [opt.name_to_print],
      sale_item: [saleItem],
      quantity: [Number(opt.quantity) || 1, [Validators.required, Validators.min(1)]],
      price: [{ value: Number(opt.price) || '', disabled: true }],
      is_default: [Number(opt.is_default)],
      display_order: [opt.display_order, [Validators.min(0)]]
    });
    // console.log('after', group.get('price')?.value, group.get('quantity')?.value); // Should show same values
    return group;
  }
  /**
   * Adds a new option to the form
   */
  addOption() {
    const optionGroup = this.builder.group({
      id: [0],
      name: ['', Validators.required],
      online_name: [''],
      name_to_print: [''],
      sale_item: [null as any], // Explicitly type as any to avoid 'never'
      quantity: [1, [Validators.required, Validators.min(1)]],
      price: [{ value: '', disabled: true }],
      is_default: [false],
      display_order: ['', [Validators.min(0)]]
    });

    const index = this.options.length;
    this.filteredSaleItemsArray[index] = this.saleItems.slice();

    optionGroup.get('sale_item')?.valueChanges.subscribe((value: any) => {
      if (value && typeof value !== 'string') {
        const priceControl = optionGroup.get('price');
        if (typeof value === 'object' && value && 'id' in value) {
          this.updatePriceFromSaleItem(optionGroup, value.id);
          priceControl?.disable();
        } else {
          priceControl?.enable();
          priceControl?.setValue('');
        }
        // this.updateDynamicColumnVisibility();
      }
    });

    // Subscribe to quantity changes and update price if sale_item is selected
    optionGroup.get('quantity')?.valueChanges.subscribe((qty: any) => {
      const saleItem = optionGroup.get('sale_item')?.value;
      if (saleItem && typeof saleItem === 'object' && saleItem.id) {
        this.updatePriceFromSaleItem(optionGroup, saleItem.id);
      }
    });

    this.options.push(optionGroup);
    this.isFormDirty = true;

    // Automatically smoothly scroll to the newly appended row
    setTimeout(() => {
      const element = document.getElementById('row-' + index);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  }

  removeOption(index: number) {
    this.options.removeAt(index);
    this.isFormDirty = true;
  }

  setDefault(index: number) {
    this.options.controls.forEach((group, i) => {
      group.get('is_default')?.setValue(i === index);
      group.get('is_default')?.markAsDirty();
    });
    this.isFormDirty = true;
  }
  /**
   * Dirtyness check
   * @returns 
   */
  isDirty(): boolean {
    return this.isFormDirty;
  }

  /**
   * checks the form is edited
   */
  navBack(): void {

    this.router.navigate(['/product/customization']);

  }

  /**
   * If tas is is null set an empty menu info
   * if menu id is not null call api to retrive the info
   * @param menuId 
   */
  setMenuInfo(menuId: any): void {
    this.customizationService.getCustomizationById(menuId).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.customizationInfo = response.data.customization;
          this.customizationOptionValues = response.data.customization_option_value;
          this.title = this.getTitle();
          this.initForm(this.customizationInfo);

          // Set existing options - sale items should already be loaded
          this.setExistingOptions(this.customizationOptionValues || []);

          this.isFormDirty = false;
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      },
      error: (error) => {
        let snackBarData: SnackBarData = {
          message: 'Failed to get data from server. Connection to the server failed.',
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
    });
  }
  setExistingOptions(options: any[]) {
    const formArray = this.editForm.get('customizationOptionValues') as FormArray;

    options.forEach((opt, index) => {
      // Initialize filtered array for this option
      this.filteredSaleItemsArray[index] = this.saleItems.slice();

      // Create the form group
      const optionGroup = this.builder.group({
        id: [opt.id],
        name: [opt.name, Validators.required],
        online_name: [opt.name_oo],
        name_to_print: [opt.name_to_print],
        sale_item: [null as any, [this.saleItemValidator]], // Explicitly type as any to avoid 'never'
        quantity: [opt.quantity],
        price: [{ value: opt.price, disabled: true }],
        is_default: [Number(opt.is_default)],
        display_order: [opt.display_order, [Validators.min(0)]]
      });

      // If a sale item is selected, find the object and set it
      if (opt.sale_item_id && Number(opt.sale_item_id) > 0) {
        const saleItemId = Number(opt.sale_item_id);
        const saleItem = this.saleItems.find(item => item.id == saleItemId);

        if (saleItem) {
          optionGroup.get('sale_item')?.setValue(saleItem);
          this.updatePriceFromSaleItem(optionGroup, saleItemId);
          optionGroup.get('price')?.disable();
        } else {
          // If we can't find it in the list, fetch it
          // this.customizationService.getSaleItemById(saleItemId).subscribe({
          //   next: (response: any) => {
          //     if (response.status === 'SUCCESS' && response.data) {
          //       // Determine if the item is in response.data.sale_item or just response.data directly
          //       const item = response.data.sale_item || response.data.item || response.data;
          //       if (item && item.id) {
          //         optionGroup.get('sale_item')?.setValue(item);
          //         optionGroup.get('price')?.setValue(item.fixed_price !== undefined ? item.fixed_price : opt.price);
          //         optionGroup.get('price')?.disable();
          //       } else {
          //         console.warn('Sale item data format is unfamiliar:', response.data);
          //       }
          //     }
          //   },
          //   error: (err) => {
          //     console.error('Failed fetching sale item by id', saleItemId, err);
          //   }
          // });
        }
      }

      // Handle value changes
      optionGroup.get('sale_item')?.valueChanges.subscribe((value: any) => {
        // Only handle non-string values here (objects)
        if (value && typeof value !== 'string') {
          const priceControl = optionGroup.get('price');
          if (typeof value === 'object' && value && 'id' in value) {
            this.updatePriceFromSaleItem(optionGroup, value.id);
            priceControl?.disable();
          } else {
            priceControl?.enable();
            priceControl?.setValue('');
          }
          this.updateDynamicColumnVisibility();
        }
      });

      // Subscribe to quantity changes and update price if sale_item is selected
      optionGroup.get('quantity')?.valueChanges.subscribe((qty: any) => {
        const saleItem = optionGroup.get('sale_item')?.value;
        if (saleItem && typeof saleItem === 'object' && saleItem.id) {
          this.updatePriceFromSaleItem(optionGroup, saleItem.id);
        }
      });

      formArray.push(optionGroup);
    });
  }

  /**
   * 
   * @returns  the title for the dialog
   * sine the same dialog is used for edit and new, dynamically decide the title
   */
  getTitle(): string {
    let title = (this.customizationInfo.id == 0 || this.customizationInfo.id == undefined) ? "New Customization" : "Editing : " + this.customizationInfo.name;
    return title;
  }
  onDepartmentCheckboxChange(event: any, department: any, index: number) {
    if (event.checked) {
      // Add if not already present
      if (!this.selectedDepartments.find(dep => dep.id === department.id)) {
        this.selectedDepartments.push(department);
      }
    } else {
      // Remove unchecked
      this.selectedDepartments = this.selectedDepartments.filter(dep => dep.id !== department.id);
    }
    this.isFormDirty = true;
    // console.log('Selected Departments:', this.selectedDepartments);
  }
  /**
     * On save
     * if the details are valid call the api to update the changes.
     */
  save(): void {
    if (this.editForm.valid) {
      // Get form values including disabled controls
      const formValues = this.editForm.getRawValue();
      console.log('Raw form values:', formValues);

      // Process customizationOptionValues to include sale_item_id
      const optionsArray = this.editForm.get('customizationOptionValues') as FormArray;
      const processedOptions = optionsArray.controls.map((control: AbstractControl) => {
        const formGroup = control as FormGroup;
        // Get values including disabled controls
        const optionData = formGroup.getRawValue();

        // Add sale_item_id property with the value from sale_item
        optionData.sale_item = optionData.sale_item && optionData.sale_item.id ? optionData.sale_item.id : null;

        // Ensure price is included (it might be disabled)
        if (optionData.price === undefined || optionData.price === null) {
          // If price is somehow missing, try to get it directly from the control
          const priceControl = formGroup.get('price');
          if (priceControl) {
            optionData.price = priceControl.value;
          }
        }

        // console.log('Processed option:', optionData);
        return optionData;
      });

      // Update the customizationInfo object with processed options
      this.customizationInfo = {
        ...this.customizationInfo,
        ...formValues,
        customizationOptionValues: processedOptions
      };

      // console.log('Sending to API:', this.customizationInfo);

      this.customizationService.update(this.customizationInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            // handle success
            this.isFormDirty = false;
            let snckBarData: SnackBarData = {
              type: 'success',
              title: 'Saved',
              message: 'The record for ' + this.customizationInfo.name + " has been updated succesfully."
            }
            this.snackBarService.openSnackBar(snckBarData);
            this.router.navigate(['/product/customization']);
          } else {
            let snackBarData: SnackBarData = {
              message: response.message,
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        },
        error: (error) => {
          // handle error
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }

  private _filterSaleItems(value: any): any[] {
    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    return this.saleItems.filter(item =>
      item.name.toLowerCase().includes(filterValue)
    );
  }

  displaySaleItem(saleItemId: number): string {
    if (saleItemId === 0) return 'Select';
    const item = this.saleItems.find(item => item.id == saleItemId);
    return item ? item.name : '';
  }

  // New method to update the total price based on quantity
  updateTotalPrice(formGroup: FormGroup, quantity: any) {
    const saleItemId = formGroup.get('sale_item')?.value;
    const basePrice = formGroup.get('price')?.value;

    if (!quantity || quantity <= 0 || !basePrice) {
      return;
    }

    // If there's a sale item selected, get its base price
    if (saleItemId && saleItemId > 0) {
      const saleItem = this.saleItems.find(item => item.id == saleItemId);
      if (saleItem) {
        const itemPrice = Number(saleItem.fixed_price ?? saleItem.shop_price ?? saleItem.price ?? 0);
        const totalPrice = itemPrice * quantity;
        // Update the price field with the calculated total
        formGroup.get('price')?.setValue(totalPrice);
      }
    } else if (basePrice) {
      // If there's no sale item but there is a base price, calculate based on that
      const numericBasePrice = parseFloat(basePrice);
      if (!isNaN(numericBasePrice)) {
        const totalPrice = numericBasePrice * quantity;
        formGroup.get('price')?.setValue(totalPrice);
      }
    }
  }

  // Add this new method to fetch and set the price from a sale item
  updatePriceFromSaleItem(formGroup: FormGroup, saleItemId: number): void {
    const saleItem = this.saleItems.find(item => item.id == saleItemId);
    const quantity = Number(formGroup.get('quantity')?.value) || 1;
    if (saleItem) {
      const itemPrice = Number(saleItem.fixed_price ?? saleItem.shop_price ?? saleItem.price ?? 0);
      formGroup.get('price')?.setValue(itemPrice * quantity);
    } else {
      // this.customizationService.getSaleItemById(saleItemId).subscribe({
      //   next: (response: any) => {
      //     if (response.status === 'SUCCESS' && response.data.sale_item) {
      //       formGroup.get('price')?.setValue(response.data.sale_item.fixed_price * quantity);
      //     }
      //   }
      // });
    }
  }

  /**
   * Filters sale items based on input for a specific row
   * @param index The index of the option in the form array
   */
  filterSaleItems(index: number): void {
    const control = this.options.at(index);
    const searchValue = control.get('sale_item')?.value;

    // If searchValue is a string, filter by it
    if (typeof searchValue === 'string') {
      const filterValue = searchValue.toLowerCase();
      this.filteredSaleItemsArray[index] = this.saleItems.filter(item =>
        item.name.toLowerCase().includes(filterValue)
      );
    }
    // If searchValue is an object, it's already selected
    else if (searchValue && typeof searchValue === 'object') {
      this.filteredSaleItemsArray[index] = this.saleItems.slice();
    }
    // Otherwise show all items
    else {
      this.filteredSaleItemsArray[index] = this.saleItems.slice();
    }
  }

  /**
   * Clears the selected sale item for a specific row
   * @param index The index of the option in the form array
   */
  clearSaleItem(index: number): void {
    const control = this.options.at(index);
    control.get('sale_item')?.setValue(null);
    control.get('price')?.setValue('');
    control.get('price')?.enable();
    this.updateDynamicColumnVisibility();
  }

  /**
   * Handles the selection of a sale item from the autocomplete
   * @param event The selection event
   * @param index The index of the option in the form array
   */
  onSaleItemSelected(event: any, index: number): void {
    const selectedItem = event.option.value;
    const control = this.options.at(index);

    // Update the form control with the selected item
    control.get('sale_item')?.setValue(selectedItem);
    this.isFormDirty = true;

    // Update price from the selected sale item
    if (selectedItem && selectedItem.id) {
      this.updatePriceFromSaleItem(control as FormGroup, selectedItem.id);
      control.get('price')?.disable();

      // Also update name fields if they're empty
      const nameControl = control.get('name');
      const nameToPrintControl = control.get('name_to_print');

      if (!nameControl?.value) {
        nameControl?.setValue(selectedItem.name);
      }

      if (!nameToPrintControl?.value) {
        nameToPrintControl?.setValue(selectedItem.name);
      }
    }

    this.updateDynamicColumnVisibility();
  }

  /**
   * Display function for the autocomplete
   * @param item The sale item to display
   * @returns The display name
   */
  displaySaleItemName(item: any): string {
    return item ? item.name : '';
  }

  // Add this function to your component class
  saleItemValidator = (control: AbstractControl) => {
    const value = control.value;
    if (!value) return null; // Allow empty (optional), or change as needed
    // If value is an object (selected from autocomplete), it's valid
    if (typeof value === 'object' && value.id) return null;
    // If value is a string, check if it matches any sale item name
    const match = this.saleItems.some(item => item.name.toLowerCase() === value.toLowerCase());
    return match ? null : { invalidSaleItem: true };
  };

  getDefaultIndex(): number {
    return this.options.controls.findIndex(ctrl => ctrl.get('is_default')?.value);
  }
}









